import { Link } from "react-router-dom";

import { SUPPORT_EMAIL, supportMailto } from "@/lib/checkout";

export const POLICY_LINKS = [
  ["/terms", "Terms", "terms"], ["/privacy", "Privacy", "privacy"], ["/child-safety", "Child Safety", "child-safety"],
  ["/safety", "Safety", "safety"], ["/guidelines", "Guidelines", "guidelines"], ["/delete-account", "Delete account", "delete-account"],
];

/** Links to every public policy page + Contact Support. `inverse` for dark backgrounds (landing). */
export function PolicyFooter({ inverse, prefix = "policy-footer" }) {
  const cls = `rounded text-[13px] font-medium underline underline-offset-2 transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${inverse ? "text-[#FDFBF7]" : "text-primary"}`;
  return (
    <footer className={`mt-10 border-t pt-5 ${inverse ? "border-white/15" : "border-border"}`} data-testid={prefix}>
      <nav aria-label="Policies" className="flex flex-wrap gap-x-5 gap-y-2">
        {POLICY_LINKS.map(([to, label, id]) => <Link key={to} to={to} className={cls} data-testid={`${prefix}-${id}-link`}>{label}</Link>)}
        <a href={supportMailto()} className={cls} data-testid={`${prefix}-support-link`}>Contact Support</a>
      </nav>
      <p className={`mt-3 text-xs ${inverse ? "text-[#FDFBF7]/60" : "text-muted-foreground"}`}>
        Questions? <a href={supportMailto()} className="underline" data-testid={`${prefix}-support-email`}>{SUPPORT_EMAIL}</a> · For adults 18+ only
      </p>
    </footer>
  );
}
